export enum ACTIONS {
    PUSH_BLUEPRINT = 'PUSH_BLUEPRINT',
    PUSH_BLUEPRINTS = 'PUSH_BLUEPRINTS',
    REMOVE_BLUEPRINT = 'REMOVE_BLUEPRINT',
    SET_BLUEPRINT_NAME = 'SET_BLUEPRINT_NAME',
    SET_BLUEPRINTS_LOADING = 'SET_BLUEPRINTS_LOADING',
}
